import { TWorkSession } from "../../common/types";
import { TResponseItemWrapper, TResponseListWrapper } from "../../common/types/common";
import { apiClient } from "../apiClient";

export const getAllWorkSessions = async ({ pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending }, filtering: { searchTerm } }): Promise<TResponseListWrapper<TWorkSession>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/WorkingSession/GetWorkingSessions?pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getWorkSession = async (id: string | number): Promise<TResponseItemWrapper<TWorkSession>> => {
    return apiClient.get(`/WorkingSession/GetWorkingSession?workingSessionId=${encodeURIComponent(id)}`);
};

export const assignJob = async ({ workingSessionId, jobId }) => {
    return apiClient.get(`/WorkingSession/AssignJob?workingSessionId=${encodeURIComponent(workingSessionId)}&jobId=${encodeURIComponent(jobId)}`);
};

export const assignOperator = async ({ workingSessionId, operatorId }) => {
    return apiClient.get(`/WorkingSession/AssignOperator?workingSessionId=${encodeURIComponent(workingSessionId)}&operatorId=${encodeURIComponent(operatorId)}`);
};

export const getWorkingSessionGeometry = async (workingSessionId: number) => {
    return apiClient.get(`/WorkingSession/GetWorkingSessionGeometry?workingSessionId=${encodeURIComponent(workingSessionId)}`);
};
